module.exports = __webpack_public_path__ + "static/img/37.cf2e8c19.png";